import { createClient } from 'contentful';
import config from 'config';
import { LanguageCode } from 'domains/language';

export default class ContentService {
  static get clients() {
    return new ContentService();
  }

  marketing = createClient({
    space: config.get('contentfulMarketingSpaceId') as string,
    accessToken: config.get('contentfulMarketingReadToken') as string,
    environment: config.get('contentfulMarketingEnvironmentId') as string,
  });

  expressable = createClient({
    space: config.get('contentfulExpressableSpaceId') as string,
    accessToken: config.get('contentfulExpressableReadToken') as string,
    environment: config.get('contentfulExpressableEnvironmentId') as string,
  });

  clinical = createClient({
    space: config.get('contentfulClinicalSpaceId') as string,
    accessToken: config.get('contentfulClinicalReadToken') as string,
    environment: config.get('contentfulClinicalEnvironmentId') as string,
  });
}

export type ContentfulLocale = 'es' | 'en-US';

export const CONTENTFUL_LOCALE_MAP: Record<LanguageCode | string, ContentfulLocale> = {
  'en-US': 'en-US',
  'es-ES': 'es',
};
